<template>
  <v-btn
    rounded="pill"
    class="bookmark-btn"
    :disabled="!smartFileLoaded"
    @click="toggleBookmark"
  >
    <v-icon class="bookmark-icon">fa-{{ isBookmarked ? "solid" : "light" }} fa-bookmark</v-icon>
    <span class="bookmark-text d-none d-md-inline">Atzīmēt tēmu</span>
  </v-btn>
</template>

<script lang="ts">
import { useSmartPageStore } from "~/stores/smartPageStore"

export default {
  setup() {
    const smartPageStore = useSmartPageStore()
    return { smartPageStore }
  },

  data() {
    return {
      isBookmarked: false as boolean,
      loadingCheck: false as boolean,
    }
  },

  computed: {
    smartFile(): any {
      return this.smartPageStore.value?.smartFile
    },
    smartFileLoaded(): boolean {
      return !!this.smartFile && !!this.smartFile.id
    },
    bookmarkingParams(): { identifier: number; type: string } | null {
      if (!this.smartFileLoaded) {
        return null
      }
      return {
        identifier: Number(this.smartFile.id),
        type: "SmartFile",
      }
    },
  },

  watch: {
    "smartPageStore.value.smartFile.id"() {
      this.checkIfBookmarked()
    },
    $route() {
      // Defer to allow store update
      this.$nextTick(() => this.checkIfBookmarked())
    },
  },

  mounted() {
    this.$nextTick(() => this.checkIfBookmarked())
  },

  methods: {
    checkIfBookmarked() {
      if (!this.bookmarkingParams) {
        return
      }
      this.loadingCheck = true
      this.smartPageStore.checkBookmarked({
        params: this.bookmarkingParams,
        successCallback: (ctx: any) => {
          this.isBookmarked = !!ctx.response._data.favourite
          this.loadingCheck = false
        },
      })
    },
    toggleBookmark() {
      if (!this.bookmarkingParams) {
        return
      }
      if (this.isBookmarked) {
        this.smartPageStore.removeBookmark({
          params: this.bookmarkingParams,
          successCallback: () => {
            this.isBookmarked = false
          },
        })
      } else {
        this.smartPageStore.bookmarkPage({
          params: this.bookmarkingParams,
          successCallback: () => {
            this.isBookmarked = true
          },
        })
      }
    },
  },
}
</script>

<style lang="sass">
.bookmark-btn
  text-transform: none
  letter-spacing: 0.1px
  font-weight: 400
  font-size: 16px
  line-height: 20px
  min-width: 0

.bookmark-icon
  margin-right: 12px
</style>
